import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'

export interface FaqPageRouteProps {
  htmlPageMetaContextProps: HtmlPageMetaContextProps
}

export type FaqPageViewModel = FaqPageRouteProps

export function fromFaqPagePropsToViewModel (props: FaqPageRouteProps): FaqPageViewModel {
  return {
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
  }
}
